export function isProbablyPhone(input: string) {
  input = input.trim();
  if (!input) {
    return false;
  }

  let digits = 0;
  for (let i = 0; i < input.length; i++) {
    if (input[i] >= '0' && input[i] <= '9') {
      digits++;
    }

    if (digits > 15) {
      return false;
    }
  }

  return digits >= 7;
}

/** Format a phone string as (XXX) XXX-XXXX when 10 digits, otherwise return as-is or placeholder */
export function formatPhone(phone: string | null | undefined): string {
  if (!phone || typeof phone !== 'string') {
    return '-';
  }
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return phone.trim() || '-';
}
